<ng-container *ngIf="bannerData$ | async as bannerData">
  <sms-info-banner
    *ngIf="(registrationStage$ | async) !== RegistrationStage.DataError"
    [badgeText]="bannerData.badgeText"
    [imageURL]="bannerData.imagePath"
    [description]="bannerData.description"
    [title]="bannerData.title"
    [badgeColor]="bannerData.badgeColor"
  ></sms-info-banner>
</ng-container>
